import { createSelector } from '@reduxjs/toolkit';

import { StoreState } from 'state/rootReducer';
import { Patient } from './patient';
import { sections } from '../components/constants';
import { mergeById } from './utils';
import { PatientHistory } from 'features/medicalRecords/patientHistory/types';

export const getPatientInfo = ({ medicalRecords }: StoreState): Patient =>
  medicalRecords.patient?.data;

export const patientHistorySelector = createSelector(
  (state: StoreState) => state.medicalRecords.currentRecord.patientHistory,
  (patientHistory: PatientHistory): Record<string, string>[] => {
    const patientHistoryArray = Object.keys(patientHistory).map((index) => {
      return {
        ...patientHistory[index],
        id: index,
      };
    });

    return mergeById(sections, patientHistoryArray);
  },
);

export const patientInfoSelector = createSelector(
  getPatientInfo,
  (patientInfo: Patient) => {
    const { birthdate_in_years, last_insurance_name, occupation } = patientInfo;

    const occupationText = occupation ? `, ${occupation}` : '';

    const infoText = `${birthdate_in_years}, ${last_insurance_name}${occupationText}`;

    return { ...patientInfo, infoText };
  },
);
